import { Skeleton } from "@flash-tecnologia/hros-web-ui-v2";
import * as ManageMembersSC from "../../steps/ManageMembers/manage-members.styles";
import { Box } from "@/components/core-components";

export const ManageMembersLoading = () => {
  return (
    <ManageMembersSC.ResponsiveContainer>
      <ManageMembersSC.Grid>
        <ManageMembersSC.LeftSection>
          <Box flex={1} $pr="xs4">
            <Skeleton height="100%" width="100%" />
          </Box>
        </ManageMembersSC.LeftSection>
        <ManageMembersSC.RightSection>
          <Skeleton height="100%" width="100%" />
        </ManageMembersSC.RightSection>
      </ManageMembersSC.Grid>
    </ManageMembersSC.ResponsiveContainer>
  );
};
